export default __webpack_public_path__ + "static/media/Facilities-CACS-24.2409e781.jpg";